import {
  postUploadFileToDB,
  getStatisticsCompareData,
  downloadCSVData,
  postStatisticsGochiData,
  postStatisticsImportData,
  getUploadFileToDB,
  getStatisticGochiStatusData
} from '../libs/apis/AutomaticStatisticsApi';

export const POST_UPLOAD_FILE_REQUEST = 'POST_UPLOAD_FILE_REQUEST';
export const POST_UPLOAD_FILE_SUCCESS = 'POST_UPLOAD_FILE_SUCCESS';
export const POST_UPLOAD_FILE_FAILURE = 'POST_UPLOAD_FILE_FAILURE';

export const GET_UPLOAD_FILE_REQUEST = 'GET_UPLOAD_FILE_REQUEST';
export const GET_UPLOAD_FILE_SUCCESS = 'GET_UPLOAD_FILE_SUCCESS';
export const GET_UPLOAD_FILE_FAILURE = 'GET_UPLOAD_FILE_FAILURE';

export const GET_STATISTICS_COMPARE_REQUEST = 'GET_STATISTICS_COMPARE_REQUEST';
export const GET_STATISTICS_COMPARE_SUCCESS = 'GET_STATISTICS_COMPARE_SUCCESS';
export const GET_STATISTICS_COMPARE_FAILURE = 'GET_STATISTICS_COMPARE_FAILURE';

export const DOWNLOAD_CSV_REQUEST = 'DOWNLOAD_CSV_REQUEST';
export const DOWNLOAD_CSV_SUCCESS = 'DOWNLOAD_CSV_SUCCESS';
export const DOWNLOAD_CSV_FAILURE = 'DOWNLOAD_CSV_FAILURE';

export const POST_STATISTICS_GOCHI_REQUEST = 'POST_STATISTICS_GOCHI_REQUEST';
export const POST_STATISTICS_GOCHI_SUCCESS = 'POST_STATISTICS_GOCHI_SUCCESS';
export const POST_STATISTICS_GOCHI_FAILURE = 'POST_STATISTICS_GOCHI_FAILURE';

export const POST_STATISTICS_IMPORT_REQUEST = 'POST_STATISTICS_IMPORT_REQUEST';
export const POST_STATISTICS_IMPORT_SUCCESS = 'POST_STATISTICS_IMPORT_SUCCESS';
export const POST_STATISTICS_IMPORT_FAILURE = 'POST_STATISTICS_IMPORT_FAILURE';

export const GET_STATISTICS_GOCHI_STATUS_REQUEST =
  'GET_STATISTICS_GOCHI_STATUS_REQUEST';
export const GET_STATISTICS_GOCHI_STATUS_SUCCESS =
  'GET_STATISTICS_GOCHI_STATUS_SUCCESS';
export const GET_STATISTICS_GOCHI_STATUS_FAILURE =
  'GET_STATISTICS_GOCHI_STATUS_FAILURE';

export const postUploadFile = params => dispatch => {
  dispatch({ type: POST_UPLOAD_FILE_REQUEST });
  return postUploadFileToDB(params)
    .then(response =>
      dispatch({
        type: POST_UPLOAD_FILE_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: POST_UPLOAD_FILE_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getUploadFile = params => dispatch => {
  dispatch({ type: GET_UPLOAD_FILE_REQUEST });
  return getUploadFileToDB(params)
    .then(response =>
      dispatch({
        type: GET_UPLOAD_FILE_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_UPLOAD_FILE_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getStatisticsCompare = params => dispatch => {
  dispatch({ type: GET_STATISTICS_COMPARE_REQUEST });
  return getStatisticsCompareData(params)
    .then(response =>
      dispatch({
        type: GET_STATISTICS_COMPARE_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_STATISTICS_COMPARE_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const postStatisticsGochi = params => dispatch => {
  dispatch({ type: POST_STATISTICS_GOCHI_REQUEST });
  return postStatisticsGochiData(params)
    .then(response =>
      dispatch({
        type: POST_STATISTICS_GOCHI_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: POST_STATISTICS_GOCHI_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const postStatisticsImport = params => dispatch => {
  dispatch({ type: POST_STATISTICS_IMPORT_REQUEST });
  return postStatisticsImportData(params)
    .then(response =>
      dispatch({
        type: POST_STATISTICS_IMPORT_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: POST_STATISTICS_IMPORT_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const downloadCSV = params => dispatch => {
  dispatch({ type: DOWNLOAD_CSV_REQUEST });
  return downloadCSVData(params)
    .then(response =>
      dispatch({
        type: DOWNLOAD_CSV_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: DOWNLOAD_CSV_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getStatisticGochiStatus = () => dispatch => {
  dispatch({ type: GET_STATISTICS_GOCHI_STATUS_REQUEST });
  return getStatisticGochiStatusData()
    .then(response =>
      dispatch({
        type: GET_STATISTICS_GOCHI_STATUS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_STATISTICS_GOCHI_STATUS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};
